import React, { useContext, useState } from "react";
import { InfoBoxTitle, InfoBoxWrapper } from "../Styled";
import { AssigneeBox } from "./Styled";
import Edit from "../../../../shared/svg/Edit";
import IconButton from "../../../../shared/components/IconButton";
import UserIcon from "../../../../shared/svg/UserIcon";
import CheckIcon from "../../../../shared/svg/CheckIcon";
import { UserSearch } from "./UserSearch";
import { api } from "../../../../shared/hooks/api";
import { error, success } from "../../../../utils/toast";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../data/enums";
import { CircularProgress } from "@mui/material";

const Content = ({
    onChangeValue,
    assignee,
    title,
    role,
    isUpdating = false,
}: {
    onChangeValue: Function;
    assignee: any;
    title: string;
    role?: string;
    isUpdating?: boolean;
}) => {
    const [isEdit, setIsEdit] = useState(false);
    const [{ data, isLoading }, fetchUsers] = api.get(
        `/users/?role=${role?.toUpperCase()}`
    );
    const [currentAssignee, setCurrentAssignee] = useState(assignee);

    const {
        user: { role: currentRole },
    } = useContext(AuthenticationContext);

    const canEdit = (toEditRole?: string) => {
        switch (toEditRole) {
            case "sale_staff":
                return [ROLE.MANAGER].includes(currentRole);
            case "logistic_staff":
                return [ROLE.MANAGER, ROLE.SALE_STAFF].includes(currentRole);
            case "production_staff":
                return [ROLE.MANAGER, ROLE.SALE_STAFF].includes(currentRole);
            case "purchasing_staff":
                return [ROLE.MANAGER, ROLE.PRODUCTION_STAFF].includes(
                    currentRole
                );
             case "first_storage_keeper":
             case "second_storage_keeper":
            return [ROLE.MANAGER, ROLE.PRODUCTION_STAFF, ROLE.PURCHASING_STAFF].includes(
                currentRole
                );
            case "storage_keeper":
            return [ROLE.MANAGER, ROLE.PRODUCTION_STAFF, ROLE.PURCHASING_STAFF].includes(
                currentRole
            );
            case "deliverer":
                return [
                    ROLE.MANAGER,
                    ROLE.STORAGE_KEEPER,
                    ROLE.FIRST_STORAGE_KEEPER,
                    ROLE.SECOND_STORAGE_KEEPER,
                    ROLE.LOGISTIC_STAFF,
                ].includes(currentRole);
            case "manager":
                return [ROLE.MANAGER].includes(currentRole);
            default:
                return false;
        }
    };

    const onClickIcon = async () => {
        if (isUpdating) return;
        if (isEdit && currentAssignee?.id !== assignee?.id) {
            await onChangeValue(currentAssignee);
        }
        setIsEdit((prev) => !prev);
    };

    return (
        <AssigneeBox>
            <div className="left">
                <div className="title">{title}</div>
                {!isEdit ? (
                    <div className="content">
                        {assignee?.display_name || "Chưa bàn giao"}{" "}
                    </div>
                ) : (
                    <div className="content">
                        <UserIcon />
                        <UserSearch
                            menuList={data?.results || []}
                            getItemText={(item: any) => item?.display_name}
                            fetchItems={fetchUsers}
                            currentValue={currentAssignee?.display_name}
                            setCurrentValue={(value: any) =>
                                setCurrentAssignee(value)
                            }
                        />
                    </div>
                )}
            </div>

            {canEdit(role) && (
                <div className="right">
                    <IconButton
                        style={{
                            width: "24px",
                            height: "24px",
                        }}
                        onClick={onClickIcon}
                        disabled={isUpdating}
                    >
                        {isUpdating ? <CircularProgress size={18} /> : !isEdit ? <Edit /> : <CheckIcon />}
                    </IconButton>
                </div>
            )}
        </AssigneeBox>
    );
};

interface AssigneeField {
    title: string;
    fieldName: string;
    role?: string;
}

export const Assignees = ({
    data,
    updateData,
    fetchData,
    fields,
}: {
    data: any;
    updateData: Function;
    fetchData: any;
    fields: AssigneeField[];
    }) => {
    const [updatingField, setUpdatingField] = useState<string | null>(null);

    const onChangeAssignee = (field: string) => async (assignee: any) => {
        if (updatingField) return;
        setUpdatingField(field);
        try {
            const data = assignee?.id
                ? { [field]: assignee?.id }
                : { [field]: "" };
            await updateData(data);
            await fetchData();
            success(
                "THÀNH CÔNG",
                "Cập nhật người đảm nhận đơn hàng thành công"
            );
        } catch (err) {
            error("Cập nhật người đảm nhận đơn hàng thất bại");
        } finally {
            setUpdatingField(null);
        }
    };

    return (
        <InfoBoxWrapper>
            <InfoBoxTitle>Phụ trách</InfoBoxTitle>
            {fields.map((item) => (
                <Content
                    key={item.fieldName}
                    title={item.title}
                    onChangeValue={onChangeAssignee(item.fieldName)}
                    assignee={(data as any)[item.fieldName as any]}
                    role={item.role}
                    isUpdating={updatingField === item.fieldName}
                />
            ))}
        </InfoBoxWrapper>
    );
};
